module.exports = __webpack_public_path__ + "static/media/sup_tropical_768.21a350fe.jpg";